function getEnv(key: string): string | undefined {
  if (typeof window === 'undefined') return undefined;

  if (!window._env_) {
    console.warn('window._env_ is not defined');
    return undefined;
  }

  const value = window._env_[key] ;
  return value ? value as string : undefined;
}

export const ENABLE_NEW_CONFIGURATOR = getEnv('REACT_APP_ENABLE_NEW_CONFIGURATOR') === 'true';
export const ENABLE_NEW_MENUBAR = getEnv('REACT_APP_ENABLE_NEW_MENUBAR') === 'true';
export const ENABLE_H5_UPGRADE = getEnv('REACT_APP_ENABLE_H5_UPGRADE') === 'true';
export const ENABLE_H5_COMING_SOON = getEnv('REACT_APP_ENABLE_H5_COMING_SOON') === 'true';
export const ENABLE_NEW_COMING_SOON = getEnv('REACT_APP_ENABLE_NEW_COMING_SOON') === 'true';
export const ENABLE_LEASE_OPTION = getEnv('REACT_APP_ENABLE_LEASE_OPTION') === 'true';
export const LEASE_OPTION = getEnv('REACT_APP_LEASE_OPTION') as 'ENABLED' | 'DISABLED' | 'COMING_SOON' | undefined;
export const CDN_DOMAIN = getEnv('REACT_APP_CDN_DOMAIN');
